if (!customElements.get('db-has' + 'pel-advisor')) {
  class HaspelAdvisor extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.catalog = JSON.parse(this.querySelector('[data-ha-catalog]').textContent);
      this.text = this.catalog.text;
      this.fields = Object.fromEntries([...this.querySelectorAll('[data-choice]')].map(e => [e.dataset.choice, e]));
      this.touched = false;
      this.reference = `HA-${Date.now().toString(36).toUpperCase()}-${(crypto.randomUUID?.() || Math.random().toString(36)).slice(-6).toUpperCase()}`;
      this.querySelector('[data-reference]').value = this.reference;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'nl-BE', {style:'currency', currency:this.dataset.currency || 'EUR'});
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-choice]')) return;
        this.touched = true;
        if (event.target === this.fields.mode) this.updateLengths();
        if (event.target === this.fields.finish) this.fields.hoseFinish.value = this.fields.finish.value;
        this.render();
        this.emit('haspel_choice_changed', {choice:event.target.dataset.choice});
      }, {signal:this.abort.signal});
      this.addEventListener('click', event => {
        const proposal = event.target.closest('[data-proposal]');
        if (proposal) {
          if (proposal.getAttribute('aria-disabled') === 'true') {event.preventDefault(); return;}
          this.selectReel(proposal.dataset.proposal);
          this.touched = true;
          this.render();
          this.emit('haspel_proposal_selected', {variant_id:proposal.dataset.proposal});
        }
        if (event.target.closest('[data-to-form]')) {
          this.touched = true;
          this.render();
          this.emit('haspel_advice_started');
        }
      }, {signal:this.abort.signal});
      const incoming = new URL(location.href).searchParams.get('haspel');
      if (incoming && this.selectReel(incoming)) this.touched = true;
      this.render();
      const form = this.querySelector('form');
      form.addEventListener('submit', event => {
        if (!form.checkValidity() || this.submitting) {
          if (this.submitting) event.preventDefault();
          return;
        }
        this.render();
        this.submitting = true;
        this.emit('haspel_advice_submitted');
      }, {signal:this.abort.signal});
      window.addEventListener('pageshow', () => {this.submitting = false;}, {signal:this.abort.signal});
      const success = this.querySelector('[data-submitted]');
      if (success) {success.focus(); this.emit('haspel_advice_confirmed');}
    }
    disconnectedCallback() {this.abort?.abort(); this.ready = false;}
    emit(name, extra = {}) {
      this.dispatchEvent(new CustomEvent(name, {bubbles:true, detail:{mode:this.fields.mode.value, ...extra}}));
    }
    updateLengths(value = this.fields.length.value) {
      const lengths = [...new Set(this.catalog.products[this.fields.mode.value].variants.map(v => v.options[0]))];
      this.fields.length.replaceChildren(...lengths.map(length => new Option(`${parseInt(length,10)} m`, length)));
      this.fields.length.value = lengths.includes(value) ? value : lengths[0];
    }
    selectReel(id) {
      for (const mode of ['automatic','manual']) {
        const variant = this.catalog.products[mode].variants.find(v => String(v.id) === String(id));
        if (!variant) continue;
        this.fields.mode.value = mode;
        this.updateLengths(variant.options[0]);
        if (mode === 'automatic') {
          this.fields.finish.value = variant.options[1] === 'RVS Koppelingen' ? '1' : '0';
          this.fields.mount.value = String(['Zonder extra voet','Met zwenkvoet','Met hoekconsole en wanddoorvoer'].indexOf(variant.options[2]));
          this.fields.hoseFinish.value = this.fields.finish.value;
        }
        return true;
      }
      return false;
    }
    render() {
      const f = Object.fromEntries(Object.entries(this.fields).map(([key,e]) => [key,e.value]));
      const automatic = f.mode === 'automatic';
      this.querySelectorAll('[data-auto-only]').forEach(e => {e.hidden = !automatic;});
      this.querySelectorAll('[data-gun-only]').forEach(e => {e.hidden = f.gun !== 'fixed';});
      this.querySelector('[data-hose-finish]').hidden = f.hoseLength === 'none';
      this.querySelector('[data-mode-note]').textContent = this.text[automatic ? 'auto_note' : 'manual_note'];
      const reelProduct = this.catalog.products[f.mode];
      const reel = reelProduct.variants.find(v => v.options[0] === f.length && (!automatic || (v.options[1] === ['Standaard koppelingen','RVS Koppelingen'][Number(f.finish)] && v.options[2] === ['Zonder extra voet','Met zwenkvoet','Met hoekconsole en wanddoorvoer'][Number(f.mount)])));
      const hoseProduct = this.catalog.products.hose;
      const hose = f.hoseLength === 'none' ? null : hoseProduct.variants.find(v => v.options[0] === ['Standaard','RVS'][Number(f.hoseFinish)] && v.options[1] === f.hoseLength);
      const gunProduct = this.catalog.products.gun;
      const gun = f.gun !== 'fixed' ? null : gunProduct.variants.find(v => v.options[0] === ['Nee','Ja'][Number(f.quick)] && v.options[1] === ['Standaard','RVS'][Number(f.guard)]);
      const invalid = !reel || (f.hoseLength !== 'none' && !hose) || (f.gun === 'fixed' && !gun);
      const lines = [];
      if (reel) lines.push({label:`${this.text[f.mode]} · ${parseInt(f.length,10)} m`,product:reelProduct,variant:reel});
      if (hose) lines.push({label:`${this.text.connect_hose} · ${parseInt(f.hoseLength,10)} m · ${this.text[Number(f.hoseFinish) ? 'stainless' : 'standard']}`,product:hoseProduct,variant:hose});
      if (gun) lines.push({label:this.text.gun_fixed,product:gunProduct,variant:gun});
      const list = this.querySelector('[data-summary-lines]');
      list.replaceChildren(...lines.map(line => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `${line.product.url}?variant=${line.variant.id}`;
        a.textContent = line.label;
        const price = document.createElement('strong');
        price.textContent = this.money.format(line.variant.price / 100);
        li.append(a,price);
        if (line.variant === reel && automatic) {
          const note = document.createElement('small');
          note.textContent = `${this.text[['mount_fixed','mount_swivel','mount_wall'][Number(f.mount)]]} · ${this.text[Number(f.finish) ? 'stainless' : 'standard']}`;
          li.append(note);
        }
        return li;
      }));
      if (!hose) {const li = document.createElement('li'); li.textContent = this.text.keep_hose; list.append(li);}
      if (!gun) {const li = document.createElement('li'); li.textContent = this.text[f.gun === 'keep' ? 'gun_keep' : 'gun_advice']; list.append(li);}
      const total = lines.reduce((sum,line) => sum + line.variant.price,0);
      this.querySelector('[data-total]').textContent = invalid ? '—' : this.money.format(total / 100);
      const availability = this.querySelector('[data-availability]');
      availability.textContent = invalid ? this.text.selection_missing : lines.some(l => !l.variant.available) ? this.text.unavailable : this.text.available;
      const snapshot = [this.text.component_total+': '+(invalid ? '—' : this.money.format(total / 100)), ...lines.map(l=>`${l.label} | ${l.variant.sku || l.variant.id} | ${l.variant.title} | ${this.money.format(l.variant.price/100)} | ${location.origin}${l.product.url}?variant=${l.variant.id}`), ...(!hose?[this.text.keep_hose]:[]), ...(!gun?[this.text[f.gun==='keep'?'gun_keep':'gun_advice']]:[]), this.text.total_note];
      this.querySelector('[data-proposal-field]').value = this.touched ? snapshot.join('\n') : this.querySelector('[data-proposal-field]').defaultValue;
    }
  }
  customElements.define('db-has' + 'pel-advisor', HaspelAdvisor);
}
if (!customElements.get('db-has-pel-product-entry')) {
  customElements.define('db-has-pel-product-entry', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-ha-current-variant]');
        if (!link) return;
        const variant = this.closest('product-info')?.querySelector('input[name="id"]')?.value;
        if (!variant || !/^\d+$/.test(variant)) return;
        const url = new URL(link.href);
        url.searchParams.set('has' + 'pel', variant);
        link.href = url.href;
      });
    }
  });
}
